import { Button, Grid, Input, Switch, InputNumber, Form, App, Tooltip } from 'antd';
import { observer } from "mobx-react-lite";
import * as React from "react";
import { useStore } from "../../root-store-context";
import { CommunitySearchList, CAT_COL_WIDTHS } from "./CommunitySearchList";
import { LOCKED_WEEK_MSG } from "../../constants/catMessages";


const { useBreakpoint } = Grid;

export const WeekInfoContent = observer(() => {

    const { userWeeklyLogStore: { addUserWeeklyLogItem, setIsEditHours, isEditHours, isDisableEditHours, isOutsideEditingWindow, NonCommunityWork, isLoading, getTotalTimeAllocatorHRS, changeNonCommunityTimeAllocatorHRS } } = useStore()

    const screens = useBreakpoint();
    const isMobile = !screens.xl;

    const { modal } = App.useApp();

    const getWarningNotification = () => {
        modal.info({
            title: `info`,
            content: "You have selected to edit your hours. This option only allows you to enter hours for the current week and for each property. Please ensure you properly document your time in hours, as you will not be able to switch back to percentages.",
        });
    }

    if (isMobile) {
        return (
            <div style={{ display: "flex", flexDirection: "column", gap: 20 }}>

                {/* Edit Hours */}
                <div className="cat-mobile-edit-hours-row">
                    <span>Edit Hours</span>
                    <Tooltip title={isOutsideEditingWindow ? LOCKED_WEEK_MSG : undefined}>
                        <Form disabled={isDisableEditHours || isOutsideEditingWindow} style={{ margin: 0 }}>
                            <Form.Item style={{ margin: 0 }}>
                                <Switch
                                    checked={isEditHours}
                                    onChange={(checked) => {
                                        setIsEditHours(checked);
                                        if (checked) getWarningNotification();
                                    }}
                                    disabled={isDisableEditHours || isOutsideEditingWindow} />
                            </Form.Item>
                        </Form>
                    </Tooltip>
                </div>

                {/* Communities */}
                <div style={{ display: "flex", flexDirection: "column", gap: 0 }}>
                    <span className="cat-mobile-section-label">Communities</span>
                    <CommunitySearchList />
                    <Tooltip title={isOutsideEditingWindow ? LOCKED_WEEK_MSG : undefined}>
                        <Button
                            size="large"
                            block
                            disabled={isLoading || isOutsideEditingWindow}
                            onClick={() => addUserWeeklyLogItem()}
                            style={{ marginTop: 8 }}
                        >
                            + Add Community
                        </Button>
                    </Tooltip>
                </div>

                {/* Non-Community Work */}
                <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
                    <Input size="large" disabled value="Non-Community Work" style={{ width: "100%" }} />
                    <div className="cat-mobile-inputs-grid">
                        <div className="cat-mobile-inputs-grid__field">
                            <label>Percentage</label>
                            <InputNumber<string>
                                size="large"
                                disabled
                                value={NonCommunityWork?.percentLogged?.toString()}
                                stringMode />
                        </div>
                        <span className="cat-mobile-inputs-grid__symbol">%</span>
                        <div className="cat-mobile-inputs-grid__field">
                            <label>Hours</label>
                            <Tooltip title={isOutsideEditingWindow ? LOCKED_WEEK_MSG : undefined}>
                                <InputNumber<string>
                                    size="large"
                                    step="0.1" min="0" max="500"
                                    disabled={!isEditHours || isOutsideEditingWindow}
                                    formatter={(value) => `${value}`}
                                    value={NonCommunityWork?.hoursLogged?.toString()}
                                    onChange={(e) => changeNonCommunityTimeAllocatorHRS(e)}
                                    stringMode />
                            </Tooltip>
                        </div>
                        <span className="cat-mobile-inputs-grid__symbol">hrs</span>
                    </div>
                </div>

                {/* Total */}
                <div className="cat-mobile-total-row">
                    <span className="cat-mobile-total-row__label">Total Hours</span>
                    <div>
                        <span className="cat-mobile-total-row__value">{getTotalTimeAllocatorHRS()}</span>
                        <span className="cat-mobile-total-row__unit">hrs</span>
                    </div>
                </div>

            </div>
        );
    }

    // Desktop
    return (
        <div className="cat-content">

            <div className="cat-content__top-bar">
                <span style={{ fontWeight: 500 }}>Community</span>
                <Tooltip title={isOutsideEditingWindow ? LOCKED_WEEK_MSG : undefined}>
                    <Form disabled={isDisableEditHours || isOutsideEditingWindow} style={{ margin: 0 }}>
                        <Form.Item label="Edit Hours" style={{ margin: 0 }}>
                            <Switch
                                data-testid="cat-btn-edit-hours"
                                size="small"
                                checked={isEditHours}
                                onChange={(checked) => {
                                    setIsEditHours(checked);
                                    if (checked) getWarningNotification();
                                }}
                                disabled={isDisableEditHours || isOutsideEditingWindow} />
                        </Form.Item>
                    </Form>
                </Tooltip>
            </div>

            <CommunitySearchList />

            <div className="cat-content__row">
                <Input data-testid="cat-input-non-community-label" size="middle" disabled value="Non-Community Work" style={{ flex: 1, minWidth: 0 }} />
                <InputNumber<string>
                    id="cat-input-non-community-percent"
                    data-testid="cat-input-non-community-percent"
                    size="middle" disabled
                    value={NonCommunityWork?.percentLogged?.toString()}
                    style={{ width: CAT_COL_WIDTHS.percent, flexShrink: 0 }}
                    stringMode />
                <span className="cat-content__row-label">%</span>
                <Tooltip title={isOutsideEditingWindow ? LOCKED_WEEK_MSG : undefined}>
                    <InputNumber<string>
                        id="cat-input-non-community-hours"
                        data-testid="cat-input-non-community-hours"
                        size="middle" step="0.1" min="0" max="500"
                        style={{ width: CAT_COL_WIDTHS.hours, flexShrink: 0 }}
                        disabled={!isEditHours || isOutsideEditingWindow}
                        formatter={(value) => `${value}`}
                        value={NonCommunityWork?.hoursLogged?.toString()}
                        onChange={(e) => changeNonCommunityTimeAllocatorHRS(e)}
                        stringMode />
                </Tooltip>
                <span className="cat-content__row-label">hrs</span>
                <span style={{ width: CAT_COL_WIDTHS.deleteBtn, flexShrink: 0 }} />
            </div>

            <div className="cat-content__row">
                <span className="cat-content__total-label">Total</span>
                <Input
                    id="cat-input-total-hours"
                    data-testid="cat-input-total-hours"
                    size="middle" disabled
                    value={getTotalTimeAllocatorHRS()}
                    suffix="hrs"
                    style={{ width: CAT_COL_WIDTHS.percent + CAT_COL_WIDTHS.label + CAT_COL_WIDTHS.hours + 16, flexShrink: 0 }} />
                <span style={{ width: CAT_COL_WIDTHS.label, flexShrink: 0 }} />
                <span style={{ width: CAT_COL_WIDTHS.deleteBtn, flexShrink: 0 }} />
            </div>

            <div>
                <Tooltip title={isOutsideEditingWindow ? LOCKED_WEEK_MSG : undefined}>
                    <Button data-testid="cat-btn-add-community" disabled={isLoading || isOutsideEditingWindow} onClick={() => addUserWeeklyLogItem()}>
                        + Add Community
                    </Button>
                </Tooltip>
            </div>

        </div>
    );
})
